import { useState } from 'react';
import ls from 'localstorage-slim';
import  randomString  from 'crypto-random-string';

export default function useToken() {
  const getToken = () => {
    const tokenString = ls.get('token-gpt-app');
    // @ts-ignore
    // const userToken = JSON.parse(tokenString);
    return tokenString
  };

  const [token, setToken] = useState(getToken());
  // @ts-ignore
  const saveToken = userToken => {
    ls.set('token-gpt-app', userToken, {ttl: 86400});
    const randomAlphanumericString = randomString({ length: 10, type: 'alphanumeric' });
    console.log(randomAlphanumericString);
    ls.set('session-id', randomAlphanumericString)
    // localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token
  }
}